import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import {
  createLocatorAsync,
  clearMessages,
  selectCreateLoading,
  selectCreateError,
  selectCreateSuccessMsg,
} from '../../redux/locatorManagement/createLocatorSlice';

export default function useCloneLocator(onSuccess) {
  const dispatch = useDispatch();
  const form = useForm({ defaultValues: { build: '', locator_type: '', locator_value: '' } });
  const [row, setRow] = useState(null);

  const loading = useSelector(selectCreateLoading);
  const error = useSelector(selectCreateError);
  const successMsg = useSelector(selectCreateSuccessMsg);

  useEffect(() => {
    if (!successMsg) return;
    const timer = setTimeout(() => dispatch(clearMessages()), 3000);
    return () => clearTimeout(timer);
  }, [successMsg, dispatch]);

  const handleOpen = (cloneRow) => {
    form.reset({
      build: '',
      locator_type: cloneRow.locator_type,
      locator_value: cloneRow.locator_value,
    });
    dispatch(clearMessages());
    setRow(cloneRow);
  };

  const handleClose = () => {
    setRow(null);
    form.reset();
    dispatch(clearMessages());
  };

  const handleSave = form.handleSubmit(async (data) => {
    try {
      await dispatch(
        createLocatorAsync({
          _isClone: true,
          market_id: row.market_id,
          platform: row.platform,
          build: Number(data.build),
          page: row.page,
          locator_name: row.locator_name,
          locator_type: data.locator_type,
          locator_value: data.locator_value,
        }),
      ).unwrap();
      setRow(null);
      onSuccess?.();
    } catch {
      // error shown via Redux state
    }
  });

  return {
    form,
    row,
    loading,
    error,
    successMsg,
    handleOpen,
    handleClose,
    handleSave,
    clearMessages: () => dispatch(clearMessages()),
  };
}
